import { render, staticRenderFns } from "./LotListParent.vue?vue&type=template&id=10d16523&"
import script from "./LotListParent.vue?vue&type=script&lang=js&"
export * from "./LotListParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports